import jsPDF from "jspdf";
import autoTable from 'jspdf-autotable';

const generateCatalog = async () => {
  try {
    console.log('Starting PDF generation...');
    console.log('Creating new jsPDF instance...');
    
    // Initialize PDF
    const doc = new jsPDF();

    // Set default font
    doc.setFont('helvetica', 'normal');
    
    console.log('jsPDF instance created successfully');
    
    // Add company header
    try {
      doc.setFontSize(24);
      doc.setTextColor(216, 47, 47); // #D82F2F
      doc.text('Triveni Industrial Gases', 105, 20, { align: 'center' });
      console.log('Added company header');
    } catch (error) {
      console.error('Error adding company header:', error);
      throw new Error('Failed to add company header: ' + error.message);
    }
    
    doc.setFontSize(14);
    doc.setTextColor(51, 51, 51); // #333333
    doc.text('Product Catalog', 105, 30, { align: 'center' });
    
    // Add company info
    try {
      doc.setFontSize(10);
      doc.setTextColor(102, 102, 102);
      doc.text('53/38 Bai Ka Bagh, Prayagraj, Uttar Pradesh', 105, 40, { align: 'center' });
      doc.text('Phone: +91 8299204736, +91 9119117385', 105, 45, { align: 'center' });
      doc.text('Email: trivenigases10@gmail.com', 105, 50, { align: 'center' });
      console.log('Added company info');
    } catch (error) {
      console.error('Error adding company info:', error);
      throw new Error('Failed to add company info: ' + error.message);
    }

    let yPos = 60;

    // Function to add section
    const addSection = (title, items, startY) => {
      try {
        console.log(`Adding section: ${title}`);
        doc.setFontSize(16);
        doc.setTextColor(216, 47, 47);
        doc.text(title, 15, startY);
        
        const tableData = items.map(item => [
          item.name || item.title,
          item.description || item.desc
        ]);

        autoTable(doc, {
          startY: startY + 5,
          head: [['Product', 'Description']],
          body: tableData,
          theme: 'grid',
          headStyles: {
            fillColor: [216, 47, 47],
            textColor: [255, 255, 255],
            fontStyle: 'bold'
          },
          styles: {
            fontSize: 10,
            cellPadding: 5,
            overflow: 'linebreak'
          },
          columnStyles: {
            0: { cellWidth: 50 },
            1: { cellWidth: 130 }
          },
          margin: { top: 10 }
        });

        console.log(`Completed section: ${title}`);
        return doc.lastAutoTable.finalY + 10;
      } catch (error) {
        console.error(`Error in addSection for ${title}:`, error);
        throw new Error(`Failed to add section ${title}: ${error.message}`);
      }
    };

    // Welding Materials
    const weldingMaterials = [
      { title: "SMAW Electrodes", description: "Stick electrodes for manual arc welding. Types include E6010, E6011, E6013, E7018, E7024" },
      { title: "GMAW Wires", description: "MIG welding wires with shielding gas requirement. Types include ER70S-3, ER70S-6, ER308L" },
      { title: "FCAW Electrodes", description: "Flux-cored wires for structural welding. Types include E71T-1, E71T-11" },
      { title: "GTAW Electrodes", description: "TIG welding rods including ER70S-2, ER308L, ER4043 & ER5356" },
      { title: "SAW Electrodes", description: "Submerged Arc Welding electrodes including EM12K, EL8, EH14" },
      { title: "Special & Hardfacing", description: "Special electrodes including E308L, E309L, E316L and hardfacing electrodes" }
    ];
    yPos = addSection('Welding Materials', weldingMaterials, yPos);

    // Gas Cylinders
    const gasCylinders = [
      { title: "Oxygen Gas Cylinder", description: "High-pressure container for medical and industrial oxygen. Used in welding, healthcare, and manufacturing." },
      { title: "Argon Gas Cylinder", description: "Used for TIG welding and inert gas applications in electronics and manufacturing." },
      { title: "Nitrogen Gas Cylinder", description: "For industrial and laboratory applications requiring inert atmosphere." },
      { title: "CO₂ Gas Cylinder", description: "Used in MIG welding and beverage industry for carbonation." },
      { title: "Dissolved Acetylene", description: "For oxy-acetylene welding and cutting operations." },
      { title: "Helium Gas Cylinder", description: "Used in MRI cooling, leak detection, and scientific research." },
      { title: "Hydrogen Gas Cylinder", description: "For fuel cells, chemical processing, and laboratory applications." }
    ];

    if (yPos > 250) {
      doc.addPage();
      yPos = 20;
    }
    yPos = addSection('Gas Cylinders', gasCylinders, yPos);

    // Ropes and Clamps
    const ropesAndClamps = [
      { title: "PP Rope", description: "High-strength polypropylene rope for construction and marine applications" },
      { title: "U Clamp", description: "For securing pipes and cables in industrial applications" },
      { title: "D Shackle", description: "For lifting and rigging applications with removable pin design" },
      { title: "Chain Pulley Block", description: "For heavy lifting operations with manual operation" },
      { title: "Wire Rope Sling", description: "For material handling and heavy lifting" },
      { title: "Web Sling", description: "Lightweight synthetic sling for delicate load lifting" }
    ];

    if (yPos > 250) {
      doc.addPage();
      yPos = 20;
    }
    yPos = addSection('Ropes, Clamps & Slings', ropesAndClamps, yPos);

    // Safety Equipment
    const safetyEquipment = [
      { title: "Head Protection", description: "Safety helmets and hard hats for industrial use" },
      { title: "Eye Protection", description: "Safety goggles and face shields for welding" },
      { title: "Hand Protection", description: "Welding gloves and safety gloves for various applications" },
      { title: "Foot Protection", description: "Safety shoes and boots with steel toe protection" },
      { title: "Safety Harness", description: "Fall protection equipment for working at heights" }
    ];

    if (yPos > 250) {
      doc.addPage();
      yPos = 20;
    }
    yPos = addSection('Safety Equipment', safetyEquipment, yPos);

    // Road & Fire Safety
    const roadAndFireSafety = [
      { title: "Speed Breaker", description: "Traffic control device for industrial zones and parking areas" },
      { title: "Safety Cones", description: "High-visibility markers for traffic management" },
      { title: "Safety Jacket", description: "High-visibility protective wear for road safety" },
      { title: "Radium Tape", description: "Reflective tape for improved visibility in low light" },
      { title: "CO₂ Fire Extinguisher", description: "For electrical and liquid fires" },
      { title: "ABC Fire Extinguisher", description: "Multipurpose fire extinguisher for various fire types" },
      { title: "Fire Blanket", description: "For smothering small fires and personal protection" },
      { title: "Fire Bucket with Stand", description: "Basic firefighting equipment for small fires" }
    ];

    if (yPos > 250) {
      doc.addPage();
      yPos = 20;
    }
    yPos = addSection('Road & Fire Safety Equipment', roadAndFireSafety, yPos);

    // Add footer
    try {
      console.log('Adding footer');
      doc.setFontSize(10);
      doc.setTextColor(102, 102, 102);
      const pageCount = doc.internal.getNumberOfPages();
      for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.text(
          `Page ${i} of ${pageCount}`,
          doc.internal.pageSize.width / 2,
          doc.internal.pageSize.height - 10,
          { align: 'center' }
        );
        doc.text(
          '© ' + new Date().getFullYear() + ' Triveni Industrial Gases. All rights reserved.',
          doc.internal.pageSize.width / 2,
          doc.internal.pageSize.height - 5,
          { align: 'center' }
        );
      }
      console.log('Added footer successfully');
    } catch (error) {
      console.error('Error adding footer:', error);
      throw new Error('Failed to add footer: ' + error.message);
    }

    // Save the PDF
    try {
      console.log('Saving PDF...');
      doc.save('Triveni-Industrial-Gases-Catalog.pdf');
      console.log('PDF generated and saved successfully!');
      return true;
    } catch (error) {
      console.error('Error saving PDF:', error);
      throw new Error('Failed to save PDF: ' + error.message);
    }
  } catch (error) {
    console.error('Error in generateCatalog:', error);
    throw error;
  }
};

export default generateCatalog; 